'use client'

import { useModalStore } from "@/context/modalStore";
import { useStateStore } from "@/context/stateStore";
import { ICycle } from "@/models/types/cycle";
import { INote } from "@/models/types/note";
import { IPlant } from "@/models/types/plant";
import { Drawer } from "@mantine/core";
import { FaSeedling, FaStickyNote } from "react-icons/fa";
import { GiCycle } from "react-icons/gi";
import { toast } from "sonner";

export default function ActionsDrawer({ openedActions, closeActions }: Readonly<{ openedActions: boolean; closeActions: () => void; }>) {

    const setCurrCycle = useStateStore(state => state.setCurrCycle);
    const setCurrPlant = useStateStore(state => state.setCurrPlant);
    const setCurrNote = useStateStore(state => state.setCurrNote);
    const iPlants = useStateStore(state => state.plants);
    const setOpenNewPlantModal = useModalStore(state => state.setOpenNewPlantModal);
    const setOpenNewCycleModal = useModalStore(state => state.setOpenNewGrowingPlantModal);
    const setOpenNewNoteModal = useModalStore(state => state.setOpenNewNoteModal);

    const handleNew = ({ type }: { type: 'plant' | 'cycle' | 'note' }) => {
        closeActions();
        if (type === 'plant') {
            setCurrPlant({} as IPlant);
            setCurrCycle({} as ICycle);
            setCurrNote({} as INote);
            setOpenNewPlantModal(true);
        } else if (type === 'cycle') {
            if (iPlants.length === 0) {
                toast.error('Create or pick a plant before adding it to Growing');
                return;
            } else {
                setCurrCycle({} as ICycle);
                setCurrPlant({} as IPlant);
                setCurrNote({} as INote);
                setOpenNewCycleModal(true);
            }
        } else if (type === 'note') {
            setCurrCycle({} as ICycle);
            setCurrPlant({} as IPlant);
            setCurrNote({} as INote);
            setOpenNewNoteModal(true);
        }
    }


    return (
        <Drawer
            variant="unstyled"
            offset={32}
            radius={'md'}
            opened={openedActions}
            onClose={() => { closeActions(); }}
            bg={'transparent'}
            color="transparent"
            title={'Which would you like to add?'}
            size="sm"

            position="top"
            styles={{
                header: { backgroundColor: '#79d198ff', padding: '6px 16px', borderBottom: '1px solid rgba(211, 231, 253, 0.69)' },
                content: { backgroundColor: '#79d198ff', height: '21.5rem' },
                body: { height: '80%' }
            }}
            closeOnClickOutside
            closeOnEscape
            overlayProps={{ blur: 4 }}
        >

            <div className={`flex flex-col justify-center items-center w-full h-full space-y-3 p-3 mt-2 bg-slate-100/70 rounded-md shadow-[inset_0_2px_8px_rgba(0,0,0,0.10),inset_0_-2px_8px_rgba(0,0,0,0.10)] border border-gray-300 overflow-hidden`}>
                <button type="button" onClick={() => handleNew({ type: 'plant' })} className="flex flex-row justify-between items-center w-full p-3 rounded-md bg-emerald-600 hover:bg-emerald-700 transition-colors hover:underline cursor-pointer">
                    <p className="text-white cursor-pointer font-medium text-md md:text-lg">
                        New Plant
                    </p>
                    <FaSeedling size={16} color="white" />
                </button>
                <button
                    type="button"
                    onClick={() => handleNew({ type: 'cycle' })}
                    className="flex flex-row justify-between items-center w-full p-3 rounded-md bg-emerald-600 hover:bg-emerald-700 transition-colors hover:underline cursor-pointer"
                >
                    <p className="text-white cursor-pointer font-medium text-md md:text-lg">
                        New Growing
                    </p>
                    <GiCycle size={16} color="white" />
                </button>
                <button className="flex flex-row justify-between items-center w-full p-3 rounded-md bg-emerald-600 hover:bg-emerald-700 transition-colors hover:underline cursor-pointer"
                    type="button"
                    onClick={() => handleNew({ type: 'note' })}
                >
                    <p className="text-white cursor-pointer font-medium text-md md:text-lg">
                        New Note
                    </p>
                    <FaStickyNote size={16} color="white" />
                </button>
            </div>

        </Drawer>
    )
}
